









import { Component, Vue } from 'vue-property-decorator';
import { ViewModes } from '@/ts/store/Constants';
import AbuseConversationActions from '@/components/Overlays/Actions/MessageActions/AbuseConversationActions.vue';

@Component({
    components: {
        AbuseConversationActions,
    },
})
export default class AbuseButton extends Vue {
    public showActions: boolean = false;

    constructor() {
        super();
    }

    get currentView() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get conversation() {
        return this.$store.getters['Messages/activeConversation'];
    }

    get userId(): number {
        return this.$store.getters['User/getUserId'];
    }

    get isUserAuthor() {
        return this.conversation.authorId === this.userId;
    }

    public showPopup() {
        if (this.currentView.viewMode === ViewModes.Messages.Messages && this.conversation) {
            this.showActions = true;
        }
    }
}
